import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import ClientPopUp from "./client_popup.js";
import MultiSelectNew from "./multiSelect.js";
import AddClient from "./addClient_popup.js";
import StatisticsClients from "./statisticsClients.js";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";
import ClientsSearch from "./clients_search.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const MySwal = withReactContent(Swal2);

const Clients = (props) => {
  const contentRef = useRef(null);
  const [page, setPage] = useState("1");
  const [perPage, setPerPage] = useState("200");
  const [expandFilters, setExpandFilters] = useState(false);
  const [clientsReportValue, setClientsReportValue] = useState([]);
  const [showClientReport, setShowClientReport] = useState(false);
  const [showAddClient, setShowAddClient] = useState(false);
  const [showStatistics, setShowStatistics] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [nameSearch, setNameSearch] = useState("");
  const [aggNumSearch, setAggNumSearch] = useState("");
  const [judgeSearch, setJudgeSearch] = useState("");
  const [lawyerSearch, setLawyerSearch] = useState([]);
  const [lawyerWezwSearch, setLawyerWezwSearch] = useState([]);
  const [lawyerSprPozwSearch, setLawyerSprPozwSearch] = useState([]);
  const [lawyerRozCaseSearch, setLawyerRozCaseSearch] = useState([]);
  const [lawyerOdpPozwSearch, setLawyerOdpPozwSearch] = useState([]);
  const [statusSearch, setStatusSearch] = useState([]);
  const [sygnSearch, setSygnSearch] = useState([]);
  const [courtSearch, setCourtSearch] = useState([]);
  const [bankSearch, setBankSearch] = useState([]);
  const [typeSearch, setTypeSearch] = useState([]);
  const [sourceSearch, setSourceSearch] = useState([]);
  const [loading, setLoading] = useState(true);
  const [arrToAccept, setArrToAccept] = useState([]);
  const [editOption, setEditOption] = useState("all");
  const [filterSpecialClient, setFilterSpecialClient] = useState(false);
  const [filterSTS, setFilterSTS] = useState(false);
  const [filterSTSK, setFilterSTSK] = useState(false);
  const [filterSUP, setFilterSUP] = useState(false);
  const [filterT1, setFilterT1] = useState(false);
  const [filterT1F, setFilterT1F] = useState(false);
  const [filterT2F, setFilterT2F] = useState(false);
  const [filterPou, setFilterPou] = useState(false);
  const [filterWezw, setFilterWezw] = useState(false);
  const [filterLawyWezw, setFilterLawyWezw] = useState(false);
  const [filterLawyOdpPozew, setFilterLawyOdpPozew] = useState(false);
  const [filterLawySprPozew, setFilterLawySprPozew] = useState(false);
  const [filterLawyRozCase, setFilterLawyRozCase] = useState(false);
  const [filterDocCompl, setFilterDocCompl] = useState(false);
  const [filterNoContactData, setFilterNoContactData] = useState(false);
  const [filterNoPayments, setFilterNoPayments] = useState(false);
  const [filterGetinOpt1, setFilterGetinOpt1] = useState(false);
  const [filterGetinOpt2, setFilterGetinOpt2] = useState(false);
  const [filterGetinSusp, setFilterGetinSusp] = useState(false);
  const [filterArch, setFilterArch] = useState(false);
  const [filterPozWz, setFilterPozWz] = useState(false);
  const [filterPotrCl, setFilterPotrCl] = useState(false);
  const [filterCofCzP, setFilterCofCzP] = useState(false);
  const [filterZatrzPotr, setFilterZatrzPotr] = useState(false);
  const [filterNakZap, setFilterNakZap] = useState(false);
  const [filterZatrzPotrDate, setFilterZatrzPotrDate] = useState(false);
  const [sort, setSort] = useState("");
  const [clients, setClients] = useState([]);
  const [clientsClear, setClientsClear] = useState([]);
  const [clientsDetail, setClientsDetail] = useState([]);
  const [clientsSygnData, setClientsSygnData] = useState([]);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);
  const [selectedOptionsLawyer, setSelectedOptionsLawyer] = useState([]);
  const [selectedOptionsLawyerWezw, setSelectedOptionsLawyerWezw] = useState(
    []
  );
  const [selectedOptionsLawyerOdpPozew, setSelectedOptionsLawyerOdpPozew] =
    useState([]);
  const [selectedOptionsLawyerSprPozew, setSelectedOptionsLawyerSprPozew] =
    useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [selectedOptionsCourt, setSelectedOptionsCourt] = useState([]);
  const [selectedOptionsBank, setSelectedOptionsBank] = useState([]);
  const [selectedOptionsType, setSelectedOptionsType] = useState([]);
  const [selectedOptionsSource, setSelectedOptionsSource] = useState([]);
  const [lawsuitsDetails, setLawsuitsDetails] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const fetchLawsuitData1 = async (clients) => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitsDataList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          try {
            var dat = JSON.parse(
              el.value
                .replaceAll(/\\n/g, "\\n")
                .replaceAll(/\\'/g, "\\'")
                .replaceAll(/\\"/g, '\\"')
                .replaceAll(/\\&/g, "\\&")
                .replaceAll(/\\r/g, "\\r")
                .replaceAll(/\\t/g, "\\t")
                .replaceAll(/\\b/g, "\\b")
                .replaceAll(/\\f/g, "\\f")
                .replaceAll(/\n/g, "\\\\n")
                .replaceAll(/\r/g, "\\\\r")
                .replaceAll(/\t/g, "\\\\t")
            ).judge;
            arr.push({ judge: dat, clientId: el.clientId });
          } catch (err) {
            console.log(el.value);
          }
        });
        setLawsuitsDetails(arr);
        handleFilterChangeRefresh("", "", getAllowedClients(clients));
        handleSortChangeRefresh();
        fetchStatuses();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchStatuses = async () => {
    var body = {
      id: +props.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [lawsuitDateFilterFrom, setLawsuitDateFilterFrom] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [lawsuitDateFilterTo, setLawsuitDateFilterTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const getNValue = () => {
    if (+page === 1) {
      return 0;
    } else {
      return +page * +perPage - +perPage;
    }
  };

  const getValue = () => {
    if (+page === 1) {
      return 200;
    } else {
      return +page * +perPage + +perPage - +perPage;
    }
  };

  const [zatrzPortDateFilterFrom, setZatrzPotrFilterFrom] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [zatrzPotrDateFilterTo, setZatrzPotrFilterTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const [serviceDateFilterFrom, setServiceDateFilterFrom] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [serviceDateFilterTo, setServiceDateFilterTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const [zaswDateFilterFrom, setZaswDateFilterFrom] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [zaswDateFilterTo, setZaswDateFilterTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const [wezwDateFilterFrom, setWezwDateFilterFrom] = useState(
    new Date().getFullYear() + "-01-01"
  );
  const [wezwDateFilterTo, setWezwDateFilterTo] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );

  const [lawsuitDateFilter, setLawsuitDateFilter] = useState(false);
  const [serviceDateFilter, setServiceDateFilter] = useState(false);
  const [zaswDateFilter, setZaswDateFilter] = useState(false);
  const [wezwDateFilter, setWezwDateFilter] = useState(false);

  const [isHoweringLawyer, setIsHoveringLawyer] = useState(false);
  const [isHoweringStatus, setIsHoveringStatus] = useState(false);
  const [isHoweringCourt, setIsHoveringCourt] = useState(false);
  const [isHoweringBank, setIsHoveringBank] = useState(false);
  const [isHoweringType, setIsHoveringType] = useState(false);
  const [isHoweringSource, setIsHoveringSource] = useState(false);
  const [current, setCurrent] = useState("");
  const [timer, setTimer] = useState(null);
  const [filterPayd, setFilterPayd] = useState(false);
  const [clientsTasks, setClientsTasks] = useState([]);
  const [clientsPayments, setClientsPayments] = useState([]);
  const [clientsPayments2, setClientsPayments2] = useState([]);
  const [clientsSygn, setClientsSygn] = useState([]);
  const [clientsT1Filter, setClientsT1Filter] = useState([]);

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const fetchClients = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClients", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchClientsTasks(data);
        return 1;
      })
      .catch((error) => {
        return 0;
      });
  };

  const checkPozWzFilter = () => {
    setFilterPozWz(!filterPozWz);
    handleFilterChange("pozwz", !filterPozWz);
  };

  const checkPotrClFilter = () => {
    setFilterPotrCl(!filterPotrCl);
    handleFilterChange("potrcl", !filterPotrCl);
  };

  const checkZatrzPotrFilter = () => {
    setFilterZatrzPotr(!filterZatrzPotr);
    handleFilterChange("zatrzpotr", !filterZatrzPotr);
  };

  const checkCofCzPFilter = () => {
    setFilterCofCzP(!filterCofCzP);
    handleFilterChange("cofczp", !filterCofCzP);
  };

  const checkNakZapFilter = () => {
    setFilterNakZap(!filterNakZap);
    handleFilterChange("nakzap", !filterNakZap);
  };

  const fetchClientsAll = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        fetchClientsTasks(data);
        return 1;
      })
      .catch((error) => {
        return 0;
      });
  };

  const fetchClientsTasks = async (clients) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsTasksV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsTasks(data);
        var arr = clients;
        arr.map((client) => {
          client.lastTaskAddDate =
            data.filter((el) => +el.id === +client.id).length > 0
              ? data.filter((el) => el.id === client.id)[0].lastTaskAddDate
              : "";
        });

        fetchClientsSygns(arr);
      })
      .catch((error) => {});
  };

  const fetchClientsSygns = async (clients) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygnV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        var arr = clients;
        arr.map((client) => {
          client.sygns =
            data.filter((el) => +el.id === +client.id).length > 0
              ? data.filter((el) => el.id === client.id)[0].sygns
              : "";
        });
        fetchClientsPayments(arr);
      })
      .catch((error) => {});
  };

  const fetchClientsPayments = async (clients) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsPaymentsV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsPayments(data);
        var arr = clients;
        arr.map((client) => {
          client.paymentsC =
            data.filter((el) => +el.id === +client.id).length > 0
              ? +data.filter((el) => el.id === client.id)[0].paymentsC
              : "0";
          client.paymentsToSettValue =
            data.filter((el) => +el.id === +client.id).length > 0
              ? +data.filter((el) => el.id === client.id)[0].paymentsToSettValue
              : "0";

          client.paymentsPayValue =
            data.filter((el) => +el.id === +client.id).length > 0
              ? +data.filter((el) => el.id === client.id)[0].paymentsPayValue
              : "0";
        });

        fetchClientsPayments2(arr);
      })
      .catch((error) => {});
  };

  const fetchClientsPayments2 = async (clients) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsPayments2V", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsPayments2([]);
        var arr = clients;
        arr.map((client) => {
          // client.paymentsC =
          //   (client.paymentsC ? client.paymentsC : 0) +
          //   (data.filter((el) => +el.id === +client.id).length > 0
          //     ? +data.filter((el) => el.id === client.id)[0].paymentsC
          //     : 0);
          // client.paymentsToSettValue =
          //   (client.paymentsToSettValue ? client.paymentsToSettValue : 0) +
          //   (data.filter((el) => +el.id === +client.id).length > 0
          //     ? +data.filter((el) => el.id === client.id)[0].paymentsToSettValue
          //     : 0);
          // client.paymentsPayValue =
          //   (client.paymentsPayValue ? client.paymentsPayValue : 0) +
          //   (data.filter((el) => +el.id === +client.id).length > 0
          //     ? +data.filter((el) => el.id === client.id)[0].paymentsPayValue
          //     : 0);
        });

        fetchClientsT1Filter(arr);
      })
      .catch((error) => {});
  };

  const fetchClientsT1Filter = async (clients) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getClientsT1FilterV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsT1Filter(data);
        var arr = clients;
        console.log("last");
        arr.map((client) => {
          client.t1Filter =
            data.filter((el) => +el.id === +client.id).length > 0
              ? data.filter((el) => +el.id === +client.id)[0].count
              : 0;
        });

        setClients(getAllowedClients(arr.filter((el) => +el.arch === 0)));
        setClientsClear(getAllowedClients(arr));
        setLoading(false);
        fetchLawsuitData1(arr);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygnData(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = (check) => {
    var chck = check ? check : 0;
    var test = check === 1 ? 0 : 0;
    if (chck === 1) {
      setLoading(true);
      if (props.team === 0) {
        test = fetchClientsAll();
      } else {
        test = fetchClients();
      }
      chck = 0;
    } else {
      setInterval(() => {
        if (test === 0) {
          setLoading(true);
          if (props.team === 0) {
            test = fetchClientsAll();
          } else {
            test = fetchClients();
          }
        }
      }, 2000);
    }
  };

  const getDataLight = (check) => {
    var chck = check ? check : 0;
    var test = check === 1 ? 0 : 0;
    if (chck === 1) {
      setLoading(true);
      if (props.team === 0) {
        test = fetchClientsAll();
      } else {
        test = fetchClients();
      }
      chck = 0;
    } else {
      setInterval(() => {
        if (test === 0) {
          setLoading(true);
          if (props.team === 0) {
            test = fetchClientsAll();
          } else {
            test = fetchClients();
          }
        }
      }, 2000);
    }
  };

  useEffect(() => {
    getData();
    setLawsuitDateFilterFrom(subMonthsFour(new Date()));
    setZaswDateFilterFrom(subMonthsFour(new Date()));
    setWezwDateFilterFrom(subMonthsFour(new Date()));
    setZatrzPotrFilterFrom(subMonthsFour(new Date()));
    setServiceDateFilterFrom(subMonthsFour(new Date()));
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setClientsReportValue(value);
    handleShowClientReport();
  };

  const handleShowClientReport = () => {
    setShowClientReport(true);
  };

  const closeClientReport = () => {
    setShowClientReport(false);
    getData(1);
  };

  const handleShowAddClient = () => {
    setShowAddClient(true);
  };

  const closeAddClient = () => {
    setShowAddClient(false);
    getDataLight();
  };

  const handleShowStatistics = () => {
    setShowStatistics(true);
  };

  const closeStatistics = () => {
    setShowStatistics(false);
    getDataLight(1);
  };

  const handleShowSearch = () => {
    setShowSearch(true);
  };

  const closeSearchs = () => {
    setShowSearch(false);
    getDataLight();
  };

  const scrollTop = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getLawyerName = (initials) => {
    var name = props.users.filter((el) => el.initials === initials)[0].name;
    return name.length > 0 ? name : "prawnik";
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygnData.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const getActualCourtForClient = (clientId) => {
    var sygns = clientsSygnData.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const chooseClient = (e) => {
    var exist = arrToAccept.filter((el) => el === e.target.value).length > 0;
    if (exist) {
      var deleteArr = arrToAccept.filter((el) => el !== e.target.value);
      setArrToAccept(deleteArr);
    } else {
      var addArr = arrToAccept;
      addArr.push(e.target.value);
      setArrToAccept(addArr);
    }
  };

  const clientsData = (
    <>
      <p style={{ fontSize: ".8vw", textAlign: "right" }}>
        Liczba spraw: {clients.length}
      </p>
      <table className="clients_table">
        <tr key={0}>
          <th>Lp.</th>
          <th>Powód</th>
          <th>Prawnik</th>
          <th>Status sprawy</th>
          <th>Aktualna sygnatura sprawy</th>
          <th>Sąd</th>
          <th>Bank</th>
          <th>WPS</th>
          <th>Rodzaj sprawy</th>
        </tr>
        {clients.slice(getNValue(), getValue()).map((el) => (
          <>
            <tr
              style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
              id={""}
              key={el.id}
            >
              <td value={el.id} onClick={handleRowClick}>
                {el.id_old}
              </td>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: "5px",
                  fontWeight: "600",
                  maxWidth: "15%",
                  wordBreak: "break-word",
                }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.petitioner}{" "}
                {props.team === 0 ? (
                  <>
                    <span style={{ color: "green" }}>- zespół {el.team}</span>
                  </>
                ) : (
                  ""
                )}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.client_owner}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.status}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.aSygn}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.aCourt}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.bank}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.wps === "" || el.wps === undefined
                  ? "brak danych"
                  : numberWithCommas(el.wps) + " PLN"}
              </td>
              <td
                style={{
                  wordBreak: "break-word",
                  width: "15%",
                  padding: "10px",
                }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.type}
              </td>
            </tr>
          </>
        ))}
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          alignItems: "flex-end",
          marginTop: "5vh",
        }}
        className="searchBoxP"
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={scrollTop}
        >
          Przejdź na górę listy
        </button>
      </div>
    </>
  );

  const clientsDataMobile = (
    <>
      <p style={{ fontSize: "2vw", textAlign: "right" }}>
        Liczba spraw: {clients.length}
      </p>
      <table className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "2vw" }}>Lp.</th>
          <th style={{ fontSize: "2vw" }}>Powód</th>
          <th style={{ fontSize: "2vw" }}>Prawnik</th>
          <th style={{ fontSize: "2vw" }}>Status sprawy</th>
        </tr>
        {clients.slice(getNValue(), getValue()).map((el) => (
          <>
            <tr
              style={el.arch === "1" ? { backgroundColor: "yellow" } : {}}
              id={""}
              key={el.id}
            >
              <td value={el.id} onClick={handleRowClick}>
                {el.id_old}
              </td>
              <td
                style={{
                  textAlign: "left",
                  paddingLeft: "5px",
                  fontWeight: "600",
                  maxWidth: "15%",
                  wordBreak: "break-word",
                }}
                value={el.id}
                onClick={handleRowClick}
              >
                {el.petitioner}{" "}
                {props.team === 0 ? (
                  <>
                    <span style={{ color: "green" }}>- zespół {el.team}</span>
                  </>
                ) : (
                  ""
                )}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.client_owner}
              </td>
              <td value={el.id} onClick={handleRowClick}>
                {el.status}
              </td>
            </tr>
          </>
        ))}
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          alignItems: "flex-end",
          marginTop: "5vh",
        }}
        className="searchBoxP"
      >
        <button
          style={{
            backgroundColor: "#00bdce",
            border: "none",
            color: "white",
            fontWeight: "600",
            borderRadius: "15px",
          }}
          id="clientsFilterButton"
          className="paymentMenuButton"
          onClick={scrollTop}
        >
          Przejdź na górę listy
        </button>
      </div>
    </>
  );

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const getLawyersForClients = () => {
    var lawyers = [];
    props.lawyersData
      .filter((e) => e.team.includes(props.team))
      .map((el) => {
        lawyers.push(el.initials);
      });

    return lawyers.filter(onlyUnique);
  };

  const getLawyersWezwForClients = () => {
    var lawyers = [];
    clients.map((el) => {
      lawyers.push(el.praw_wezw);
    });

    return lawyers.filter(onlyUnique);
  };

  const getLawyersOdpPozwForClients = () => {
    var lawyers = [];
    clients.map((el) => {
      lawyers.push(el.praw_pozew);
    });

    return lawyers.filter(onlyUnique);
  };

  const getLawyersSprPozwForClients = () => {
    var lawyers = [];
    clients.map((el) => {
      lawyers.push(el.praw_spr_pozew);
    });

    return lawyers.filter(onlyUnique);
  };

  const getStatusForClients = () => {
    var status = [];
    statuses.map((el) => {
      status.push(el.name);
    });

    return status;
  };

  const getCourtForClients = () => {
    var status = [];
    props.courtsData.map((el) => {
      status.push(el.name);
    });

    return status.filter(onlyUnique);
  };

  const getBankForClients = () => {
    var status = [];
    props.banksData
      .filter((e) => e.team.includes("1"))
      .map((el) => {
        status.push(el.name);
      });

    return status.filter(onlyUnique);
  };

  const getTypesForClients = () => {
    var status = [];
    status.push("pozew przeciwko bankowi");
    status.push(
      "pozew banku o opłatę za korzystanie z kapitału i zwrot kapitału"
    );
    status.push("pozew banku o opłatę za korzystanie z kapitału");
    status.push("pozew banku z tytułu wypowiedzenia umowy");
    status.push("pozew banku o waloryzację");
    status.push("pozew banku o zwrot kapitału");
    status.push("sankcja kredytu darmowego");
    status.push("pozew banku o zwrot kapitału i jego waloryzację");
    status.push("EURO - pozew przeciwko bankowi");
    status.push("WIBOR - pozew przeciwko bankowi");
    status.push("antywindykacja");

    return status.filter(onlyUnique);
  };

  const checkOption = (arr, value) => {
    if (arr.filter((el) => el === value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleLawyerWezwSearchChange = (e) => {
    setLawyerWezwSearch(e.target.value);
    handleFilterChange("lawyerw", e.target.value);
  };

  const handleLawyerOdpPozwSearchChange = (e) => {
    setLawyerOdpPozwSearch(e.target.value);
    handleFilterChange("lawyerop", e.target.value);
  };

  const handleLawyerSprPozwSearchChange = (e) => {
    setLawyerSprPozwSearch(e.target.value);
    handleFilterChange("lawyersp", e.target.value);
  };

  const handleLawyerRozCaseSearchChange = (e) => {
    setLawyerRozCaseSearch(e.target.value);
    handleFilterChange("lawyerrc", e.target.value);
  };

  const handleTypeSearchChange = (e) => {
    setTypeSearch(e);
    handleFilterChange("type", e);
  };

  const handleSourceSearchChange = (e) => {
    setSourceSearch(e);
    handleFilterChange("source", e);
  };

  const handleStatusSearchChange = (e) => {
    setStatusSearch(e);
    handleFilterChange("status", e);
  };

  const handleLawyerSearchChange = (e) => {
    setLawyerSearch(e);
    handleFilterChange("lawyer", e);
  };

  const checkWezwFilter = () => {
    setFilterWezw(!filterWezw);
    handleFilterChange("wezw", !filterWezw);
  };

  const checkArchFilter = () => {
    setFilterArch(!filterArch);
    handleFilterChange("arch", !filterArch);
  };

  const checkPaydFilter = () => {
    setFilterPayd(!filterPayd);
    handleFilterChange("payd", !filterPayd);
  };

  const checkOdpPozewFilter = () => {
    setFilterLawyOdpPozew(!filterLawyOdpPozew);
    handleFilterChange("ppozw", !filterLawyOdpPozew);
  };

  const checkSprPozewFilter = () => {
    setFilterLawySprPozew(!filterLawySprPozew);
    handleFilterChange("pspozw", !filterLawySprPozew);
  };

  const checkPrawWezwFilter = () => {
    setFilterLawyWezw(!filterLawyWezw);
    handleFilterChange("docs", !filterLawyWezw);
  };

  const checkDocComplFilter = () => {
    setFilterDocCompl(!filterDocCompl);
    handleFilterChange("docs", !filterDocCompl);
  };

  const checkNoContactDatalFilter = () => {
    setFilterNoContactData(!filterNoContactData);
    handleFilterChange("contact", !filterNoContactData);
  };

  const checkNoPaymentsFilter = () => {
    setFilterNoPayments(!filterNoPayments);
    handleFilterChange("paymentsC", !filterNoPayments);
  };

  const checkGetinOpt1Filter = () => {
    setFilterGetinOpt1(!filterGetinOpt1);
    handleFilterChange("getin_opt_1", !filterGetinOpt1);
  };

  const checkGetinOpt2Filter = () => {
    setFilterGetinOpt2(!filterGetinOpt2);
    handleFilterChange("getin_opt_2", !filterGetinOpt2);
  };

  const checkGetinSuspFilter = () => {
    setFilterGetinSusp(!filterGetinSusp);
    handleFilterChange("getin_susp", !filterGetinSusp);
  };

  const checkSpecialClientFilter = () => {
    setFilterSpecialClient(!filterSpecialClient);
    handleFilterChange("special", !filterSpecialClient);
  };

  const checkSTSFilter = () => {
    setFilterSTS(!filterSTS);
    handleFilterChange("sts", !filterSTS);
  };

  const checkSTSKFilter = () => {
    setFilterSTSK(!filterSTSK);
    handleFilterChange("stsk", !filterSTSK);
  };

  const checkSUPFilter = () => {
    setFilterSUP(!filterSUP);
    handleFilterChange("sup", !filterSUP);
  };

  const checkT1ClientFilter = () => {
    setClients(clientsClear);
    setFilterT1(!filterT1);
    setFilterT1F(false);
    handleFilterChange("t1", !filterT1);
  };

  const checkT1FClientFilter = () => {
    setClients(clientsClear);
    setFilterT1F(!filterT1F);
    setFilterT1(false);
    handleFilterChange("t1f", !filterT1F);
  };

  const checkT2FClientFilter = () => {
    setClients(clientsClear);
    setFilterT2F(!filterT2F);
    handleFilterChange("t2f", !filterT2F);
  };

  const checkPouClientFilter = () => {
    setClients(clientsClear);
    setFilterPou(!filterPou);
    handleFilterChange("pou", !filterPou);
  };

  const handleAddPage = () => {
    if (+page * +perPage < clients.length) {
      setPage(+page + 1);
    }
  };

  const handleSubPage = () => {
    if (+page > 1) {
      setPage(+page - 1);
    }
  };

  const checkJudge = (clientId, value) => {
    if (
      lawsuitsDetails.filter((el) =>
        +el.clientId === +clientId && el.judge
          ? el.judge
              .toString()
              .toLowerCase()
              .replaceAll(" ", "")
              .includes(value.toString().toLowerCase().replaceAll(" ", ""))
          : false
      ).length > 0
    ) {
      return true;
    }
    return false;
  };

  const handleFilterChange = (type, value) => {
    setPage(1);
    var arr = clientsClear;

    if (!(type === "arch" ? value : filterArch)) {
      arr = arr.filter((el) => el.arch === "0");
    }

    if (type === "arch" ? value : filterArch) {
      arr = arr.filter((el) => el.arch === "1" || el.arch === "0");
    }

    if (!(type === "pozwz" ? value : filterPozWz)) {
      arr = arr.filter(
        (el) =>
          el.counterclaim === "TAK" ||
          el.counterclaim === "NIE" ||
          !el.counterclaim
      );
    }

    if (type === "pozwz" ? value : filterPozWz) {
      arr = arr.filter((el) => el.counterclaim === "TAK");
    }

    if (type === "aggNum" ? value : aggNumSearch) {
      var sv = type === "aggNum" ? value : aggNumSearch;
      arr = arr.filter((el) =>
        el.credit_aggr_num
          .toString()
          .toLowerCase()
          .includes(sv.toString().toLowerCase())
      );
    }

    if (type === "payd" ? value : filterPayd) {
      arr = arr.filter((el) => el.payed === "1");
    }

    if (!(type === "payd" ? value : filterPayd)) {
      arr = arr.filter((el) => el.payed !== "0" || el.payed !== "1");
    }

    if ((type === "name" ? value : nameSearch).length > 0) {
      arr = arr.filter((el) =>
        el.petitioner
          .toString()
          .toLowerCase()
          .includes(
            (type === "name" ? value : nameSearch).toString().toLowerCase()
          )
      );
    }

    if ((type === "judge" ? value : judgeSearch).length > 0) {
      arr = arr.filter((el) =>
        checkJudge(el.id, type === "judge" ? value : judgeSearch)
      );
    }

    if ((type === "sygn" ? value : sygnSearch).length > 0) {
      var sv = type === "sygn" ? value : sygnSearch;
      if (sv === "brak") {
        arr = arr.filter((el) => el.sygns.toString().length < 5);
      } else {
        arr = arr.filter((el) =>
          el.sygns
            .toString()
            .toLowerCase()
            .includes(
              (type === "sygn" ? value : sygnSearch).toString().toLowerCase()
            )
        );
      }
    }

    if ((type === "court" ? value : courtSearch).length > 0) {
      var cs = type === "court" ? value : courtSearch;
      var ts = [];
      arr.map((el) => {
        cs.map((ex) => {
          if (
            el.aCourt
              .toString()
              .toLowerCase()
              .includes(ex.toString().toLowerCase())
          ) {
            ts.push(el);
          }
        });
      });

      arr = ts;
    }

    if ((type === "bank" ? value : bankSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "bank" ? value : bankSearch, el.bank)
      );
    }

    if ((type === "status" ? value : statusSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "status" ? value : statusSearch, el.status)
      );
    }

    if ((type === "source" ? value : sourceSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "source" ? value : sourceSearch, el.source)
      );
    }

    if ((type === "type" ? value : typeSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "type" ? value : typeSearch, el.type)
      );
    }

    if ((type === "lawyer" ? value : lawyerSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "lawyer" ? value : lawyerSearch, el.client_owner)
      );
    }

    if ((type === "lawyersp" ? value : lawyerSprPozwSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyersp" ? value : lawyerSprPozwSearch) ===
          el.praw_spr_pozew
      );
    }

    if ((type === "lawyerrc" ? value : lawyerRozCaseSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyerrc" ? value : lawyerRozCaseSearch) === el.rozCase
      );
    }

    if ((type === "lawyerop" ? value : lawyerOdpPozwSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyerop" ? value : lawyerOdpPozwSearch) === el.praw_pozew
      );
    }

    if ((type === "lawyerw" ? value : lawyerWezwSearch).length > 0) {
      arr = arr.filter(
        (el) => (type === "lawyerw" ? value : lawyerWezwSearch) === el.praw_wezw
      );
    }

    if (type === "special" ? value : filterSpecialClient) {
      arr = arr.filter((el) => el.special_client === "TAK");
    }

    if (type === "sts" ? value : filterSTS) {
      arr = arr.filter((el) => el.sts === "TAK");
    }

    if (type === "stsk" ? value : filterSTSK) {
      arr = arr.filter((el) => el.stsk === "TAK");
    }

    if (type === "sup" ? value : filterSUP) {
      arr = arr.filter((el) => el.sup === "TAK");
    }

    if (type === "t1" ? value : filterT1) {
      arr = arr.filter((el) => +el.t1Filter > 0);
    }

    if (type === "t1f" ? value : filterT1F) {
      arr = arr.filter((el) => +el.t1Filter === 0);
    }

    if (type === "t2f" ? value : filterT2F) {
      arr = arr.filter((el) => el.pozN === "TAK");
    }

    if (type === "pou" ? value : filterPou) {
      arr = arr.filter((el) => el.pou === "TAK");
    }

    if (type === "paymentsC" ? value : filterNoPayments) {
      arr = arr.filter((el) => +el.paymentsC === 0);
    }

    if (type === "getin_opt_1" ? value : filterGetinOpt1) {
      arr = arr.filter((el) => +el.getin_opt1 === 1);
    }

    if (type === "getin_opt_2" ? value : filterGetinOpt2) {
      arr = arr.filter((el) => +el.getin_opt2 === 1);
    }

    if (type === "contact" ? value : filterNoContactData) {
      arr = arr.filter(
        (el) =>
          el.phone === "" ||
          el.phone === "brak danych" ||
          el.email === "" ||
          el.email === "brak danych"
      );
    }

    if (type === "docs" ? value : filterDocCompl) {
      arr = arr.filter(
        (el) => el.data_zasw !== "" && el.data_zasw !== undefined
      );
    }

    if (type === "pwezw" ? value : filterLawyWezw) {
      arr = arr.filter(
        (el) =>
          el.praw_wezw === "" ||
          el.praw_wezw === undefined ||
          el.praw_wezw === "brak danych"
      );
    }

    if (type === "pwezw" ? value : filterLawyWezw) {
      arr = arr.filter(
        (el) =>
          el.praw_wezw === "" ||
          el.praw_wezw === undefined ||
          el.praw_wezw === "brak danych"
      );
    }

    if (type === "pspozw" ? value : filterLawySprPozew) {
      arr = arr.filter(
        (el) =>
          el.praw_spr_pozew === "" ||
          el.praw_spr_pozew === undefined ||
          el.praw_spr_pozew === "brak danych"
      );
    }

    if (type === "ppozw" ? value : filterLawyOdpPozew) {
      arr = arr.filter(
        (el) =>
          el.praw_pozew === "" ||
          el.praw_pozew === undefined ||
          el.praw_pozew === "brak danych"
      );
    }

    if (type === "wezw" ? value : filterWezw) {
      arr = arr.filter(
        (el) => el.data_wezw !== "" && el.data_wezw !== undefined
      );
    }

    if (type === "dateLawsuit" ? value : lawsuitDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.lawsuit_date) >= new Date(lawsuitDateFilterFrom) &&
          new Date(el.lawsuit_date) <= new Date(lawsuitDateFilterTo)
      );
    }

    if (type === "dateService" ? value : serviceDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.service_aggrement_date) >=
            new Date(serviceDateFilterFrom) &&
          new Date(el.service_aggrement_date) <= new Date(serviceDateFilterTo)
      );
    }

    if (type === "dateZasw" ? value : zaswDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.data_zasw) >= new Date(zaswDateFilterFrom) &&
          new Date(el.data_zasw) <= new Date(zaswDateFilterTo)
      );
    }

    if (type === "dateWezw" ? value : wezwDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.data_wezw) >= new Date(wezwDateFilterFrom) &&
          new Date(el.data_wezw) <= new Date(wezwDateFilterTo)
      );
    }

    if (!(type === "potrcl" ? value : filterPotrCl)) {
      arr = arr;
    }

    if (type === "zatrzpotr" ? value : filterZatrzPotr) {
      arr = arr.filter((el) => el.zatrz_potr === "TAK");
    }

    if (!(type === "zatrzpotr" ? value : filterZatrzPotr)) {
      arr = arr;
    }

    if (type === "cofczp" ? value : filterCofCzP) {
      arr = arr.filter((el) => el.cofCzP === "TAK");
    }

    if (!(type === "cofczp" ? value : filterCofCzP)) {
      arr = arr;
    }

    if (type === "nakzap" ? value : filterNakZap) {
      arr = arr.filter((el) => el.nakZap === "TAK");
    }

    if (!(type === "nakzap" ? value : filterNakZap)) {
      arr = arr;
    }

    if (type === "getin_susp" ? value : filterGetinSusp) {
      arr = arr.filter((el) => el.getin_susp === "TAK");
    }

    if (!(type === "getin_susp" ? value : filterGetinSusp)) {
      arr = arr;
    }

    if (type === "dateZatrzPotr" ? value : filterZatrzPotrDate) {
      arr = arr.filter(
        (el) =>
          new Date(el.zatrz_potr_date) >= new Date(zatrzPortDateFilterFrom) &&
          new Date(el.zatrz_potr_date) <= new Date(zatrzPotrDateFilterTo)
      );
    }

    if (type === "potrcl" ? value : filterPotrCl) {
      arr = arr.filter((el) => el.potrCl === "TAK");
    }

    setClients(arr);
  };

  const handleFilterChangeRefresh = (type, value, data) => {
    var arr = data;

    if (!(type === "arch" ? value : filterArch)) {
      arr = arr.filter((el) => el.arch === "0");
    }

    if (type === "arch" ? value : filterArch) {
      arr = arr.filter((el) => el.arch === "1" || el.arch === "0");
    }

    if (!(type === "pozwz" ? value : filterPozWz)) {
      arr = arr.filter(
        (el) =>
          el.counterclaim === "TAK" ||
          el.counterclaim === "NIE" ||
          !el.counterclaim
      );
    }

    if (type === "aggNum" ? value : aggNumSearch) {
      var sv = type === "aggNum" ? value : aggNumSearch;
      arr = arr.filter((el) =>
        el.credit_aggr_num
          .toString()
          .toLowerCase()
          .includes(sv.toString().toLowerCase())
      );
    }

    if (type === "pozwz" ? value : filterPozWz) {
      arr = arr.filter((el) => el.counterclaim === "TAK");
    }

    if (type === "payd" ? value : filterPayd) {
      arr = arr.filter((el) => el.payed === "1");
    }

    if (!(type === "payd" ? value : filterPayd)) {
      arr = arr.filter((el) => el.payed !== "0" || el.payed !== "1");
    }

    if ((type === "name" ? value : nameSearch).length > 0) {
      arr = arr.filter((el) =>
        el.petitioner
          .toString()
          .toLowerCase()
          .includes(
            (type === "name" ? value : nameSearch).toString().toLowerCase()
          )
      );
    }

    if ((type === "judge" ? value : judgeSearch).length > 0) {
      if (type === "judge" ? value : judgeSearch === "") {
        arr = arr;
      }
      arr = arr.filter((el) =>
        checkJudge(el.id, type === "judge" ? value : judgeSearch)
      );
    }

    if ((type === "sygn" ? value : sygnSearch).length > 0) {
      arr = arr.filter((el) =>
        el.sygns
          .toString()
          .toLowerCase()
          .includes(
            (type === "lawyer" ? value : sygnSearch).toString().toLowerCase()
          )
      );
    }

    if ((type === "court" ? value : courtSearch).length > 0) {
      var cs = type === "court" ? value : courtSearch;
      var ts = [];
      arr.map((el) => {
        cs.map((ex) => {
          if (
            el.aCourt
              .toString()
              .toLowerCase()
              .includes(ex.toString().toLowerCase())
          ) {
            ts.push(el);
          }
        });
      });

      arr = ts;
    }

    if ((type === "bank" ? value : bankSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "bank" ? value : bankSearch, el.bank)
      );
    }

    if ((type === "status" ? value : statusSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "status" ? value : statusSearch, el.status)
      );
    }

    if ((type === "source" ? value : sourceSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "source" ? value : sourceSearch, el.source)
      );
    }

    if ((type === "type" ? value : typeSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "type" ? value : typeSearch, el.type)
      );
    }

    if ((type === "lawyer" ? value : lawyerSearch).length > 0) {
      arr = arr.filter((el) =>
        checkOption(type === "lawyer" ? value : lawyerSearch, el.client_owner)
      );
    }

    if ((type === "lawyersp" ? value : lawyerSprPozwSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyersp" ? value : lawyerSprPozwSearch) ===
          el.praw_spr_pozew
      );
    }

    if ((type === "lawyerrc" ? value : lawyerRozCaseSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyerrc" ? value : lawyerRozCaseSearch) === el.rozCase
      );
    }

    if ((type === "lawyerop" ? value : lawyerOdpPozwSearch).length > 0) {
      arr = arr.filter(
        (el) =>
          (type === "lawyerop" ? value : lawyerOdpPozwSearch) === el.praw_pozew
      );
    }

    if ((type === "lawyerw" ? value : lawyerWezwSearch).length > 0) {
      arr = arr.filter(
        (el) => (type === "lawyerw" ? value : lawyerWezwSearch) === el.praw_wezw
      );
    }

    if (type === "special" ? value : filterSpecialClient) {
      arr = arr.filter((el) => el.special_client === "TAK");
    }

    if (type === "sts" ? value : filterSTS) {
      arr = arr.filter((el) => el.sts === "TAK");
    }

    if (type === "stsk" ? value : filterSTSK) {
      arr = arr.filter((el) => el.stsk === "TAK");
    }

    if (type === "sup" ? value : filterSUP) {
      arr = arr.filter((el) => el.sup === "TAK");
    }

    if (type === "paymentsC" ? value : filterNoPayments) {
      arr = arr.filter((el) => +el.paymentsC === 0);
    }

    if (type === "contact" ? value : filterNoContactData) {
      arr = arr.filter(
        (el) =>
          el.phone === "" ||
          el.phone === "brak danych" ||
          el.email === "" ||
          el.email === "brak danych"
      );
    }

    if (type === "docs" ? value : filterDocCompl) {
      arr = arr.filter(
        (el) => el.data_zasw !== "" && el.data_zasw !== undefined
      );
    }

    if (type === "pwezw" ? value : filterLawyWezw) {
      arr = arr.filter(
        (el) =>
          el.praw_wezw === "" ||
          el.praw_wezw === undefined ||
          el.praw_wezw === "brak danych"
      );
    }

    if (type === "pwezw" ? value : filterLawyWezw) {
      arr = arr.filter(
        (el) =>
          el.praw_wezw === "" ||
          el.praw_wezw === undefined ||
          el.praw_wezw === "brak danych"
      );
    }

    if (type === "pspozw" ? value : filterLawySprPozew) {
      arr = arr.filter(
        (el) =>
          el.praw_spr_pozew === "" ||
          el.praw_spr_pozew === undefined ||
          el.praw_spr_pozew === "brak danych"
      );
    }

    if (type === "t1" ? value : filterT1) {
      arr = arr.filter((el) => +el.t1Filter > 0);
    }

    if (type === "t1F" ? value : filterT1F) {
      arr = arr.filter((el) => +el.t1Filter === 0);
    }

    if (type === "t2f" ? value : filterT2F) {
      arr = arr.filter((el) => el.pozN === "TAK");
    }

    if (type === "pou" ? value : filterPou) {
      arr = arr.filter((el) => el.pou === "TAK");
    }

    if (type === "ppozw" ? value : filterLawyOdpPozew) {
      arr = arr.filter(
        (el) =>
          el.praw_pozew === "" ||
          el.praw_pozew === undefined ||
          el.praw_pozew === "brak danych"
      );
    }

    if (type === "wezw" ? value : filterWezw) {
      arr = arr.filter(
        (el) => el.data_wezw !== "" && el.data_wezw !== undefined
      );
    }

    if (type === "dateLawsuit" ? value : lawsuitDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.lawsuit_date) >= new Date(lawsuitDateFilterFrom) &&
          new Date(el.lawsuit_date) <= new Date(lawsuitDateFilterTo)
      );
    }

    if (type === "dateService" ? value : serviceDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.service_aggrement_date) >=
            new Date(serviceDateFilterFrom) &&
          new Date(el.service_aggrement_date) <= new Date(serviceDateFilterTo)
      );
    }

    if (type === "dateZasw" ? value : zaswDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.data_zasw) >= new Date(zaswDateFilterFrom) &&
          new Date(el.data_zasw) <= new Date(zaswDateFilterTo)
      );
    }

    if (type === "dateWezw" ? value : wezwDateFilter) {
      arr = arr.filter(
        (el) =>
          new Date(el.data_wezw) >= new Date(wezwDateFilterFrom) &&
          new Date(el.data_wezw) <= new Date(wezwDateFilterTo)
      );
    }

    if (!(type === "potrcl" ? value : filterPotrCl)) {
      arr = arr;
    }

    if (type === "potrcl" ? value : filterPotrCl) {
      arr = arr.filter((el) => el.potrCl === "TAK");
    }

    if (type === "zatrzpotr" ? value : filterZatrzPotr) {
      arr = arr.filter((el) => el.zatrz_potr === "TAK");
    }

    if (!(type === "zatrzpotr" ? value : filterZatrzPotr)) {
      arr = arr;
    }

    if (type === "cofczp" ? value : filterCofCzP) {
      arr = arr.filter((el) => el.cofCzP === "TAK");
    }

    if (!(type === "cofczp" ? value : filterCofCzP)) {
      arr = arr;
    }

    if (type === "nakzap" ? value : filterNakZap) {
      arr = arr.filter((el) => el.nakZap === "TAK");
    }

    if (!(type === "nakzap" ? value : filterNakZap)) {
      arr = arr;
    }

    if (type === "getin_susp" ? value : filterGetinSusp) {
      arr = arr.filter((el) => el.getin_susp === "TAK");
    }

    if (!(type === "getin_susp" ? value : filterGetinSusp)) {
      arr = arr;
    }

    if (type === "dateZatrzPotr" ? value : filterZatrzPotrDate) {
      arr = arr.filter(
        (el) =>
          new Date(el.zatrz_potr_date) >= new Date(zatrzPortDateFilterFrom) &&
          new Date(el.zatrz_potr_date) <= new Date(zatrzPotrDateFilterTo)
      );
    }

    setClients(arr);
  };

  const handleLawsuitDateFilter = (e) => {
    setLawsuitDateFilter(!lawsuitDateFilter);
    handleFilterChange("dateLawsuit", !lawsuitDateFilter);
  };

  const handleServiceDateFilter = (e) => {
    setServiceDateFilter(!serviceDateFilter);
    handleFilterChange("dateService", !serviceDateFilter);
  };

  const handleZatrzPotrDateFilter = (e) => {
    setFilterZatrzPotrDate(!filterZatrzPotrDate);
    handleFilterChange("dateZatrzPotr", !filterZatrzPotrDate);
  };

  const handleZaswDateFilter = (e) => {
    setLawsuitDateFilter(!zaswDateFilter);
    handleFilterChange("dateZasw", !zaswDateFilter);
  };

  const handleWezwDateFilter = (e) => {
    setLawsuitDateFilter(!wezwDateFilter);
    handleFilterChange("dateWezw", !wezwDateFilter);
  };

  const handleNameSearchChange = (e) => {
    setNameSearch(e.target.value);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      handleFilterChange("name", e.target.value);
    }, 1000);

    setTimer(newTimer);
  };

  const handleJudgeSearchChange = (e) => {
    setJudgeSearch(e.target.value);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      handleFilterChange("judge", e.target.value);
    }, 1000);

    setTimer(newTimer);
  };

  const handleSygnSearchChange = (e) => {
    setSygnSearch(e.target.value);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      handleFilterChange("sygn", e.target.value);
    }, 1000);

    setTimer(newTimer);
  };

  const handleAggNumSearchChange = (e) => {
    setAggNumSearch(e.target.value);

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      handleFilterChange("aggNum", e.target.value);
    }, 1000);

    setTimer(newTimer);
  };

  const handleCourtSearchChange = (e) => {
    setCourtSearch(e);
    handleFilterChange("court", e);
  };

  const handleBankSearchChange = (e) => {
    setBankSearch(e);
    handleFilterChange("bank", e);
  };

  const handleFilterClear = () => {
    setPage(1);
    setLawyerSearch([]);
    setNameSearch("");
    setStatusSearch([]);
    setJudgeSearch("");
    setSygnSearch("");
    setAggNumSearch("");
    setBankSearch([]);
    setCourtSearch([]);
    setTypeSearch([]);
    setSelectedOptionsLawyer([]);
    setSelectedOptionsStatus([]);
    setSelectedOptionsBank([]);
    setSelectedOptionsCourt([]);
    setSelectedOptionsType([]);
    setSelectedOptionsSource([]);
    setFilterDocCompl(false);
    setFilterArch(false);
    setFilterPou(false);

    setFilterLawyOdpPozew(false);
    setFilterLawySprPozew(false);
    setFilterLawyRozCase(false);
    setFilterLawyWezw(false);
    setFilterSpecialClient(false);
    setFilterWezw(false);
    setFilterNoContactData(false);
    setFilterNoPayments(false);
    setFilterPayd(false);
    setLawyerWezwSearch([]);
    setLawyerOdpPozwSearch([]);
    setLawyerSprPozwSearch([]);
    setLawyerRozCaseSearch([]);
    setLawsuitDateFilterFrom(subMonthsFour(new Date()));
    setServiceDateFilterFrom(subMonthsFour(new Date()));
    setZaswDateFilterFrom(subMonthsFour(new Date()));
    setWezwDateFilterFrom(subMonthsFour(new Date()));
    setZaswDateFilterTo(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setServiceDateFilterTo(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setWezwDateFilterTo(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setWezwDateFilterTo(
      new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1) +
        "-" +
        (new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate())
    );
    setWezwDateFilter(false);
    setZaswDateFilter(false);
    setLawsuitDateFilter(false);
    setServiceDateFilter(false);
    setClients(clientsClear.filter((el) => el.arch === "0"));
    setSort("");
  };

  const handleFilterAddClear = () => {
    setClients(clientsClear);
    setFilterLawyOdpPozew(false);
    setFilterLawySprPozew(false);
    setFilterLawyWezw(false);
    setFilterSpecialClient(false);
  };

  const getLawyersOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "brak danych" });

    getLawyersForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });
    return arr;
  };

  const getSourcesOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });
    arr.push({ label: "Własna", value: "własna" });
    arr.push({ label: "LEX CHF", value: "LEX CHF" });
    arr.push({ label: "FREJOWSKI CHF", value: "FREJOWSKI CHF" });

    return arr;
  };

  const getLawyersWezwOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "none" });

    getLawyersWezwForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });
    return arr;
  };

  const getLawyersOdpPozwOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "none" });

    getLawyersOdpPozwForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });
    return arr;
  };

  const getLawyersSprPozwOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "none" });

    getLawyersSprPozwForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });
    return arr;
  };

  const getLawyersOptionsNew = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "brak danych" });

    getLawyersForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });

    return arr;
  };

  const getStatusOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "brak danych" });

    statuses.map((el) => {
      var opt = { label: el.name, value: el.name };
      arr.push(opt);
    });

    return arr;
  };

  const getCourtOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "brak danych" });

    getCourtForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });

    return arr;
  };

  const getBankOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "none" });

    getBankForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });

    return arr;
  };

  const getTypeOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszyscy", value: "all" });
    arr.push({ label: "Brak danych", value: "none" });

    getTypesForClients().map((el) => {
      var opt = { label: el, value: el };
      arr.push(opt);
    });

    return arr;
  };

  const handleExpandFiltersClick = (e) => {
    setExpandFilters(!expandFilters);
  };

  const checkEditOption = (option) => {
    if (editOption === "all") {
      return true;
    } else if (option === editOption) {
      return true;
    } else {
      return false;
    }
  };

  const handleSortChange = (e) => {
    //setLoading(true);
    if (e.target.value === "sort1") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw) >
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw)
        )
      );
    } else if (e.target.value === "sort2") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw) <
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw)
        )
      );
    } else if (e.target.value === "sort3") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            ) >
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            )
        )
      );
    } else if (e.target.value === "sort4") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            ) <
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            )
        )
      );
    } else if (e.target.value === "sort5") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw) >
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw)
        )
      );
    } else if (e.target.value === "sort6") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw) <
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw)
        )
      );
    } else if (e.target.value === "sort7") {
      setClients(clients.sort((a, b) => +a.id - +b.id));
    } else if (e.target.value === "sort8") {
      setClients(clients.sort((a, b) => +b.id - +a.id));
    } else if (e.target.value === "sort9") {
      setClients(
        clients.sort(
          (a, b) => new Date(a.lastTaskAddDate) - new Date(b.lastTaskAddDate)
        )
      );
    } else if (e.target.value === "sort10") {
      setClients(
        clients.sort(
          (a, b) => new Date(b.lastTaskAddDate) - new Date(a.lastTaskAddDate)
        )
      );
    }

    setSort(e.target.value);
    setLoading(false);
  };

  const handleSortChangeRefresh = (e) => {
    if (sort === "sort1") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw) >
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw)
        )
      );
    } else if (sort === "sort2") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_zasw.length === 0 ? "1900-01-01" : b.data_zasw) <
            new Date(a.data_zasw.length === 0 ? "1900-01-01" : a.data_zasw)
        )
      );
    } else if (sort === "sort3") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            ) >
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            )
        )
      );
    } else if (sort === "sort4") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(
              b.lawsuit_date.length === 0 ? "1900-01-01" : b.lawsuit_date
            ) <
            new Date(
              a.lawsuit_date.length === 0 ? "1900-01-01" : a.lawsuit_date
            )
        )
      );
    } else if (sort === "sort5") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw) >
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw)
        )
      );
    } else if (sort === "sort6") {
      setClients(
        clients.sort(
          (a, b) =>
            new Date(b.data_wezw.length === 0 ? "1900-01-01" : b.data_wezw) <
            new Date(a.data_wezw.length === 0 ? "1900-01-01" : a.data_wezw)
        )
      );
    } else if (sort === "sort7") {
      setClients(clients.sort((a, b) => +a.id - +b.id));
    } else if (sort === "sort8") {
      setClients(clients.sort((a, b) => +b.id - +a.id));
    } else if (sort === "sort9") {
      setClients(
        clients.sort(
          (a, b) => new Date(a.lastTaskAddDate) - new Date(b.lastTaskAddDate)
        )
      );
    } else if (sort === "sort10") {
      setClients(
        clients.sort(
          (a, b) => new Date(b.lastTaskAddDate) - new Date(a.lastTaskAddDate)
        )
      );
    }
  };

  const handleLawsuitDateFilterFrom = (e) => {
    if (new Date(e.target.value) > new Date(lawsuitDateFilterTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setLawsuitDateFilterFrom(e.target.value);
  };

  const handleLawsuitDateFilterTo = (e) => {
    if (new Date(e.target.value) < new Date(lawsuitDateFilterFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setLawsuitDateFilterTo(e.target.value);
  };

  const handleServiceDateFilterFrom = (e) => {
    if (new Date(e.target.value) > new Date(serviceDateFilterTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setServiceDateFilterFrom(e.target.value);
  };

  const handleZatrzPotrDateFilterFrom = (e) => {
    if (new Date(e.target.value) > new Date(zatrzPotrDateFilterTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setZatrzPotrFilterFrom(e.target.value);
  };

  const handleServiceDateFilterTo = (e) => {
    if (new Date(e.target.value) < new Date(serviceDateFilterFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setServiceDateFilterTo(e.target.value);
  };

  const handleZatrzPotrDateFilterTo = (e) => {
    if (new Date(e.target.value) < new Date(zatrzPortDateFilterFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setZatrzPotrFilterTo(e.target.value);
  };

  const handleZaswDateFilterFrom = (e) => {
    if (new Date(e.target.value) > new Date(zaswDateFilterTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setZaswDateFilterFrom(e.target.value);
  };

  const handleZaswDateFilterTo = (e) => {
    if (new Date(e.target.value) < new Date(zaswDateFilterFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setZaswDateFilterTo(e.target.value);
  };

  const handleWezwDateFilterFrom = (e) => {
    if (new Date(e.target.value) > new Date(zaswDateFilterTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setWezwDateFilterFrom(e.target.value);
  };

  const handleWezwDateFilterTo = (e) => {
    if (new Date(e.target.value) < new Date(wezwDateFilterFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może byćmniejsza niż "Data od"',
      });
      return;
    }
    setWezwDateFilterTo(e.target.value);
  };

  const createLawyerOptions = (e) => {
    var bankOptions = [];
    props.lawyersData
      .filter((el) => el.team.includes("1"))
      .map((el) => {
        bankOptions.push({ name: el.name, value: el.name });
      });

    return bankOptions;
  };

  const scrollBottom = (e) => {
    const divToScrollTo = document.getElementById("testScroll");
    window.scrollTo({
      top: divToScrollTo.clientHeight,
      behavior: "smooth",
    });
  };

  const createExcelDS = () => {
    var tab = [];
    tab.push([
      "ID",
      "Powód",
      "Prawnik",
      "Status sprawy",
      "Aktualna sygnatura",
      "Aktualny sąd",
      "Bank",
      "Notatka do sprawy",
      "Wniosek o zabezpieczenie",
      "Data otrzymania zaświadczenia od klienta",
      "Sporządzający wezwanie do zapłaty",
      "Data wezwania do zapłaty",
      "Osoba odpowiedzialna za pozew",
      "Osoba sprawdzająca pozew",
    ]);
    clients.slice(getNValue(), getValue()).map((el) => {
      tab.push([
        el.id_old,
        el.petitioner,
        el.client_owner,
        el.status,
        el.aSygn,
        el.aCourt,
        el.bank,
        el.note,
        el.application_for_protection,
        el.data_zasw,
        el.praw_wezw,
        el.data_wezw,
        el.praw_pozew,
        el.praw_spr_pozew,
      ]);
    });
    return tab;
  };

  const getSum = () => {
    var sum = 0;
    var quant = clients.filter(
      (x) => x.status === "zakończona - rozliczona"
    ).length;
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        sum =
          sum +
          (el.paymentsToSettValue
            ? parseFloat(el.paymentsToSettValue.toString().replaceAll(".", ","))
            : 0);
      });

    return sum / quant;
  };

  const getSum2 = () => {
    var sum = 0;
    var quant = clients.filter(
      (x) => x.status === "zakończona - rozliczona"
    ).length;
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        sum =
          sum +
          (el.paymentsPayValue
            ? parseFloat(el.paymentsPayValue.toString().replaceAll(".", ","))
            : 0);
      });

    return sum / quant;
  };

  const createExcelIN = () => {
    var tab = [];
    tab.push([
      "ID",
      "Powód",
      "Prawnik",
      "Status sprawy",
      "Data zakończenia",
      "Przychód do rozliczenia",
      "Przychód rozliczony",
    ]);
    clients
      .filter((x) => x.status === "zakończona - rozliczona")
      .map((el) => {
        tab.push([
          el.id_old,
          el.petitioner,
          el.client_owner,
          el.status,
          el.closeDate !== null && el.closeDate !== "" > 0
            ? el.closeDate
            : "nie uzupełniono",
          parseFloat(el.paymentsToSettValue.toString().replaceAll(".", ",")),
          parseFloat(el.paymentsPayValue.toString().replaceAll(".", ",")),
        ]);
      });
    tab.push(["", "", "", "", "", "", ""]);

    tab.push([
      "Średnia",
      "",
      "",
      "",
      "",
      getSum().toFixed(2).toString().replaceAll(".", ","),
      getSum2().toFixed(2).toString().replaceAll(".", ","),
    ]);
    return tab;
  };

  const exportToExcel = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelDS());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const exportToExcelIN = (e) => {
    const worksheet = XLSX.utils.json_to_sheet(createExcelIN());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dane");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "dane.xlsx");
  };

  const subMonthsFour = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setMonth(newDate.getMonth() + 1 - 4));
    return (
      retDate.getFullYear() +
      "-" +
      (retDate.getMonth() < 10
        ? "0" + retDate.getMonth()
        : retDate.getMonth()) +
      "-" +
      (retDate.getDate() < 10 ? "0" + retDate.getDate() : retDate.getDate())
    );
  };

  const handleLawyerIn = () => {
    setIsHoveringLawyer(true);
    setIsHoveringBank(false);
    setIsHoveringCourt(false);
    setIsHoveringStatus(false);
    setIsHoveringType(false);
    setIsHoveringSource(false);
  };

  const handleLawyerOut = () => {
    setIsHoveringLawyer(false);
  };

  const handleBankIn = () => {
    setIsHoveringLawyer(false);
    setIsHoveringBank(true);
    setIsHoveringCourt(false);
    setIsHoveringStatus(false);
    setIsHoveringType(false);
    setIsHoveringSource(false);
  };

  const handleBankOut = () => {
    setIsHoveringBank(false);
  };

  const handleCourtIn = () => {
    setIsHoveringLawyer(false);
    setIsHoveringBank(false);
    setIsHoveringCourt(true);
    setIsHoveringStatus(false);
    setIsHoveringType(false);
    setIsHoveringSource(false);
  };

  const handleCourtOut = () => {
    setIsHoveringCourt(false);
  };

  const handleStatusIn = () => {
    setIsHoveringLawyer(false);
    setIsHoveringBank(false);
    setIsHoveringCourt(false);
    setIsHoveringStatus(true);
    setIsHoveringType(false);
    setIsHoveringSource(false);
  };

  const handleStatusOut = () => {
    setIsHoveringStatus(false);
  };

  const handleTypeIn = () => {
    setIsHoveringLawyer(false);
    setIsHoveringBank(false);
    setIsHoveringCourt(false);
    setIsHoveringStatus(false);
    setIsHoveringType(true);
    setIsHoveringSource(false);
  };

  const handleTypeOut = () => {
    setIsHoveringType(false);
  };

  const handleSourceIn = () => {
    setIsHoveringLawyer(false);
    setIsHoveringBank(false);
    setIsHoveringCourt(false);
    setIsHoveringStatus(false);
    setIsHoveringType(false);
    setIsHoveringSource(true);
  };

  const handleSourceOut = () => {
    setIsHoveringSource(false);
  };

  const closeAllHovering = (e) => {
    if (
      e.target.id !== "lawyer" &&
      e.target.id !== "bank" &&
      e.target.id !== "court" &&
      e.target.id !== "status" &&
      e.target.id !== "type" &&
      e.target.id !== "source" &&
      e.currentTarget.id !== "lawyer" &&
      e.currentTarget.id !== "bank" &&
      e.currentTarget.id !== "court" &&
      e.currentTarget.id !== "status" &&
      e.currentTarget.id !== "type" &&
      e.currentTarget.id !== "source"
    ) {
      setIsHoveringLawyer(false);
      setIsHoveringBank(false);
      setIsHoveringCourt(false);
      setIsHoveringStatus(false);
      setIsHoveringType(false);
      setIsHoveringSource(false);
    }
  };

  const desktopFilters = (
    <>
      {props.team === 2 ? (
        <>
          <div
            style={{
              marginTop: "5vh",
              marginBottom: "0vh",
              height: "10vh",
            }}
            className="filtersClients"
          >
            <div
              style={{ marginBottom: "0vh", width: "23.4%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Źródło sprawy</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getSourcesOptions()}
                  value={typeSearch}
                  onChange={handleSourceSearchChange}
                  selectedOptions={selectedOptionsSource}
                  setSelectedOptions={setSelectedOptionsSource}
                  isHovering={isHoweringSource}
                  setIsHovering={setIsHoveringSource}
                  id={"source"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}

      <div
        style={{ marginTop: "5vh", marginBottom: "0vh" }}
        className="filtersClients"
      >
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Imię i nazwisko klienta</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={nameSearch}
            onChange={handleNameSearchChange}
          />
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Prawnik</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getLawyersOptions()}
              value={lawyerSearch}
              onChange={handleLawyerSearchChange}
              selectedOptions={selectedOptionsLawyer}
              setSelectedOptions={setSelectedOptionsLawyer}
              isHovering={isHoweringLawyer}
              setIsHovering={setIsHoveringLawyer}
              id={"lawyer"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>

        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Status sprawy</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getStatusOptions()}
              value={statusSearch}
              onChange={handleStatusSearchChange}
              selectedOptions={selectedOptionsStatus}
              setSelectedOptions={setSelectedOptionsStatus}
              isHovering={isHoweringStatus}
              setIsHovering={setIsHoveringStatus}
              id={"status"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Sygnatura sprawy</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={sygnSearch}
            onChange={handleSygnSearchChange}
          />
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Sąd</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getCourtOptions()}
              value={courtSearch}
              onChange={handleCourtSearchChange}
              selectedOptions={selectedOptionsCourt}
              setSelectedOptions={setSelectedOptionsCourt}
              isHovering={isHoweringCourt}
              setIsHovering={setIsHoveringCourt}
              id={"court"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Bank</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getBankOptions()}
              value={bankSearch}
              onChange={handleBankSearchChange}
              selectedOptions={selectedOptionsBank}
              setSelectedOptions={setSelectedOptionsBank}
              isHovering={isHoweringBank}
              setIsHovering={setIsHoveringBank}
              id={"bank"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Rodzaj</label>
          <div className="multiContainer">
            <MultiSelectNew
              options={getTypeOptions()}
              value={typeSearch}
              onChange={handleTypeSearchChange}
              selectedOptions={selectedOptionsType}
              setSelectedOptions={setSelectedOptionsType}
              isHovering={isHoweringType}
              setIsHovering={setIsHoveringType}
              id={"type"}
              closeAllHovering={closeAllHovering}
            />
          </div>
        </div>
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Numer umowy kredytowej</label>
          <input
            type="text"
            id="clientsFilterInput"
            name="name"
            value={aggNumSearch}
            onChange={handleAggNumSearchChange}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginBottom: "0vh",
            marginTop: "3vh",
            width: "50%",
            gap: "20px",
          }}
          className="searchBoxP"
        >
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={handleFilterClear}
          >
            Wyczyść filtr
          </button>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={scrollBottom}
          >
            Przejdź na dół listy
          </button>
          <button
            style={{
              backgroundColor: "#00bdce",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "15px",
            }}
            id="clientsFilterButton"
            className="paymentMenuButton"
            onClick={exportToExcel}
          >
            EXPORT
          </button>
          {props.user.exportFinansowy === "1" ? (
            <>
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={exportToExcelIN}
              >
                EXPORT PRZYCHODY ROZLICZONE
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>

      <div
        style={{
          justifyContent: "right",
          marginBottom: "2vh",
          marginTop: "3vh",
        }}
        className="filtersClients"
      >
        <div
          style={{ marginBottom: "0vh", width: "23.4%" }}
          className="searchBoxP"
        >
          <label id="clientsFilterLabel">Sortuj według</label>
          <select
            type="text"
            id="clientsFilterInput"
            name="name"
            value={sort}
            onChange={handleSortChange}
          >
            {sort === "" ? (
              <option key={10} value="sortX">
                Wybierz...
              </option>
            ) : (
              ""
            )}
            <option key={0} value="sort1">
              Data otrzymania zaświadczenia - od najstarszej
            </option>
            <option key={1} value="sort2">
              Data otrzymania zaświadczenia - od najmłodszej
            </option>
            <option key={2} value="sort3">
              Data nadania pozwu - od najstarszej
            </option>
            <option key={3} value="sort4">
              Data nadania pozwu - od najmłodszej
            </option>
            <option key={4} value="sort5">
              Data wezwania do zapłaty - od najstarszej
            </option>
            <option key={5} value="sort6">
              Data wezwania do zapłaty - od najmłodszej
            </option>
            <option key={6} value="sort7">
              Według identyfikatora - rosnąco
            </option>
            <option key={7} value="sort8">
              Według identyfikatora - malejąco
            </option>
            <option key={8} value="sort9">
              Data dodania ostatniego zadania - od najstarszej
            </option>
            <option key={9} value="sort10">
              Data dodania ostatniego zadania - od najmłodszej
            </option>
          </select>
        </div>
      </div>
    </>
  );

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          {props.team === 2 ? (
            <>
              <div
                style={{
                  marginTop: "5vh",
                  marginBottom: "0vh",
                  height: "10vh",
                }}
                className="filtersClients"
              >
                <div
                  style={{ marginBottom: "0vh", width: "23.4%" }}
                  className="searchBoxP"
                >
                  <label id="clientsFilterLabel">Źródło sprawy</label>
                  <div className="multiContainer">
                    <MultiSelectNew
                      options={getSourcesOptions()}
                      value={typeSearch}
                      onChange={handleSourceSearchChange}
                      selectedOptions={selectedOptionsSource}
                      setSelectedOptions={setSelectedOptionsSource}
                      isHovering={isHoweringSource}
                      setIsHovering={setIsHoveringSource}
                      id={"source"}
                      closeAllHovering={closeAllHovering}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          <div
            style={{ marginTop: "0vh", marginBottom: "0vh" }}
            className="filtersClients"
          >
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Imię i nazwisko klienta</label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={nameSearch}
                onChange={handleNameSearchChange}
              />
            </div>
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Prawnik</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getLawyersOptions()}
                  value={lawyerSearch}
                  onChange={handleLawyerSearchChange}
                  selectedOptions={selectedOptionsLawyer}
                  setSelectedOptions={setSelectedOptionsLawyer}
                  isHovering={isHoweringLawyer}
                  setIsHovering={setIsHoveringLawyer}
                  id={"lawyer"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>

            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Status sprawy</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getStatusOptions()}
                  value={statusSearch}
                  onChange={handleStatusSearchChange}
                  selectedOptions={selectedOptionsStatus}
                  setSelectedOptions={setSelectedOptionsStatus}
                  isHovering={isHoweringStatus}
                  setIsHovering={setIsHoveringStatus}
                  id={"status"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Sygnatura sprawy</label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={sygnSearch}
                onChange={handleSygnSearchChange}
              />
            </div>
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Sąd</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getCourtOptions()}
                  value={courtSearch}
                  onChange={handleCourtSearchChange}
                  selectedOptions={selectedOptionsCourt}
                  setSelectedOptions={setSelectedOptionsCourt}
                  isHovering={isHoweringCourt}
                  setIsHovering={setIsHoveringCourt}
                  id={"court"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Bank</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getBankOptions()}
                  value={bankSearch}
                  onChange={handleBankSearchChange}
                  selectedOptions={selectedOptionsBank}
                  setSelectedOptions={setSelectedOptionsBank}
                  isHovering={isHoweringBank}
                  setIsHovering={setIsHoveringBank}
                  id={"bank"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Rodzaj</label>
              <div className="multiContainer">
                <MultiSelectNew
                  options={getTypeOptions()}
                  value={typeSearch}
                  onChange={handleTypeSearchChange}
                  selectedOptions={selectedOptionsType}
                  setSelectedOptions={setSelectedOptionsType}
                  isHovering={isHoweringType}
                  setIsHovering={setIsHoveringType}
                  id={"type"}
                  closeAllHovering={closeAllHovering}
                />
              </div>
            </div>

            <div
              style={{ marginBottom: "3vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Numer umowy kredytowej</label>
              <input
                type="text"
                id="clientsFilterInput"
                name="name"
                value={aggNumSearch}
                onChange={handleAggNumSearchChange}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                marginBottom: "0vh",
                width: "100%",
                gap: "20px",
                flexWrap: "wrap",
              }}
              className="searchBoxP"
            >
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  width: "100%",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={handleFilterClear}
              >
                Wyczyść filtr
              </button>
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  width: "100%",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={scrollBottom}
              >
                Przejdź na dół listy
              </button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              flexWrap: "wrap",
              marginBottom: "0vh",
              width: "100%",
              gap: "20px",
              marginTop: "20px",
            }}
            className="searchBoxP"
          >
            <button
              style={{
                backgroundColor: "#00bdce",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "15px",
                width: "100%",
              }}
              id="clientsFilterButton"
              className="paymentMenuButton"
              onClick={exportToExcel}
            >
              EXPORT
            </button>
            {props.user.exportFinansowy === "1" ? (
              <>
                <button
                  style={{
                    backgroundColor: "#00bdce",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                    width: "100%",
                  }}
                  id="clientsFilterButton"
                  className="paymentMenuButton"
                  onClick={exportToExcelIN}
                >
                  EXPORT PRZYCHODY ROZLICZONE
                </button>
              </>
            ) : (
              ""
            )}
          </div>
          <div
            style={{
              justifyContent: "right",
              marginBottom: "2vh",
              marginTop: "3vh",
            }}
            className="filtersClients"
          >
            <div
              style={{ marginBottom: "0vh", width: "100%" }}
              className="searchBoxP"
            >
              <label id="clientsFilterLabel">Sortuj według</label>
              <select
                type="text"
                id="clientsFilterInput"
                name="name"
                value={sort}
                onChange={handleSortChange}
              >
                {sort === "" ? (
                  <option key={10} value="sortX">
                    Wybierz...
                  </option>
                ) : (
                  ""
                )}
                <option key={0} value="sort1">
                  Data otrzymania zaświadczenia - od najstarszej
                </option>
                <option key={1} value="sort2">
                  Data otrzymania zaświadczenia - od najmłodszej
                </option>
                <option key={2} value="sort3">
                  Data nadania pozwu - od najstarszej
                </option>
                <option key={3} value="sort4">
                  Data nadania pozwu - od najmłodszej
                </option>
                <option key={4} value="sort5">
                  Data wezwania do zapłaty - od najstarszej
                </option>
                <option key={5} value="sort6">
                  Data wezwania do zapłaty - od najmłodszej
                </option>
                <option key={6} value="sort7">
                  Według identyfikatora - rosnąco
                </option>
                <option key={7} value="sort8">
                  Według identyfikatora - malejąco
                </option>
              </select>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  const checkAllowedClient = (id) => {
    var bool = false;
    props.user.allowedClients.split(",").map((el) => {
      if (el === id) {
        bool = true;
      }
    });

    return bool;
  };

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <div
          id="reportC"
          className="mainContainerClients"
          onClick={closeAllHovering}
        >
          {showAddClient ? (
            <AddClient
              clientsSheetData={props.clientsSheetData}
              lawyersData={props.lawyersData}
              courtsData={props.courtsData}
              banksData={props.banksData}
              close={closeAddClient}
              refreshData={props.refreshData}
              logClientAction={props.logClientAction}
              paymentsSheetData={props.paymentsSheetData}
              users={props.usersData}
              mode={"add"}
              editOption={editOption}
              checkEditOption={checkEditOption}
              userRole={props.user.role}
              userMail={props.user.mail}
              userPhone={props.user.phone}
              team={props.team}
              user={props.user}
              userD={props.user}
            />
          ) : (
            ""
          )}
          {showStatistics ? (
            <StatisticsClients
              close={closeStatistics}
              clients={clients}
              banksData={props.banksData}
              courtsData={props.courtsData}
            />
          ) : (
            ""
          )}
          {showSearch ? (
            <ClientsSearch
              close={closeSearchs}
              filesData={props.filesData}
              clientsData={
                props.user.allowedClients === "all"
                  ? props.clientsData
                  : props.clientsData.filter((el) =>
                      checkAllowedClient(el.identifier)
                    )
              }
              clientsSheetData={props.clientsSheetData}
              refreshData={props.refreshData}
              user={props.user}
              clientsLogsData={props.clientsLogsData}
              clientsLogsSheetData={props.clientsLogsSheetData}
              logClientAction={props.logClientAction}
              tr={props.tr}
              logLeadAction={props.logLeadAction}
              generateAnalysis={props.generateAnalysis}
              clientId={props.payId}
              tabIndex={props.tabIndex}
              checkPermissions={props.checkPermissions}
              clientsContactData={props.clientsContactData}
              clientsContactSheetData={props.clientsContactSheetData}
              paymentsData={props.paymentsData}
              paymentsSheetData={props.paymentsSheetData}
              transactionsData={props.transactionsData}
              transactionsSheetData={props.transactionsSheetData}
              transactionsNaData={props.transactionsNaData}
              transactionsNaSheetData={props.transactionsNaSheetData}
              paymentsArchiveData={props.paymentsArchiveData}
              paymentsArchiveSheetData={props.paymentsArchiveSheetData}
              hearingsData={props.hearingsData}
              hearingsSheetData={props.hearingsSheetData}
              tasksData={props.tasksData}
              tasksSheetData={props.tasksSheetData}
              closeDatePopUp={props.closeDatePopUp}
              closeTaskPopUp={props.closeTaskPopUp}
              lawyersData={props.lawyersData}
              courtsData={props.courtsData}
              banksData={props.banksData}
              usersData={props.usersData}
              resultsData={props.resultsData}
              tasksTypesData={props.tasksTypesData}
              closeReportPopUp={props.closeReportPopUp}
              checkPermissions={props.checkPermissions}
              substitutesData={props.substitutesData}
              taskTypesData={props.tasksTypesData}
              users={props.usersData}
              team={props.team}
              tasksTeam2Data={props.tasksTeam2Data}
              hearingsTeam2Data={props.hearingsTeam2Data}
              hearingsTeam2SheetData={props.hearingsTeam2SheetData}
              tasksTeam2SheetData={props.tasksTeam2SheetData}
              archDateTeam2={props.hearingsArchTeam2SheetData}
              archTasksTeam2={props.tasksArchTeam2SheetData}
              archTasks={props.tasksArchSheetData}
              clientsSygnData={props.clientsSygnData}
              clientsSygnSheetData={props.clientsSygnSheetData}
              clientsQuestData={props.clientsQuestData}
              clientsQuestSheetData={props.clientsQuestSheetData}
            />
          ) : (
            ""
          )}
          {showClientReport ? (
            <ClientPopUp
              logLeadAction={props.logLeadAction}
              generateAnalysis={props.generateAnalysis}
              close={closeClientReport}
              paymentsData={props.paymentsData}
              paymentsSheetData={props.paymentsSheetData}
              transactionsSheetData={props.transactionsSheetData}
              transactionsASheetData={props.transactionsNaSheetData}
              transactionsData={props.transactionsData}
              paymentsArchiveSheetData={props.paymentsArchiveSheetData}
              id={clientsReportValue}
              team={props.team}
              refreshData={props.refreshData}
              user={props.user.name}
              clientsData={
                clients.filter((el) => +el.id === +clientsReportValue)[0]
              }
              clientsSheetData={props.clientsSheetData}
              userRole={props.user.role}
              userMail={props.user.mail}
              userPhone={props.user.phone}
              userPhone={props.user.phone}
              substitutesData={props.substitutesData}
              tasksData={props.tasksData}
              hearingsData={props.hearingsData}
              hearingsSheetData={props.hearingsSheetData}
              tasksSheetData={props.tasksSheetData}
              lawyersData={props.lawyersData}
              courtsData={props.courtsData}
              banksData={props.banksData}
              users={props.usersData}
              resultsData={props.resultsData}
              tasksTypesData={props.tasksTypesData}
              checkPermissions={props.checkPermissions}
              hearingsTeam2Data={props.hearingsTeam2Data}
              hearingsTeam2SheetData={props.hearingsTeam2SheetData}
              tasksTeam2Data={props.tasksTeam2Data}
              tasksTeam2SheetData={props.tasksTeam2SheetData}
              archTasksTeam2={props.archTasksTeam2}
              archDateTeam2={props.archDateTeam2}
              archDate={props.archDate}
              clientsSygnData={props.clientsSygnData}
              clientsSygnSheetData={props.clientsSygnSheetData}
              actualSygn={
                clientsClear.filter((el) => +el.id === +clientsReportValue)[0]
                  .aSygn
              }
              clientsContactData={props.clientsContactData}
              clientsContactSheetData={props.clientsContactSheetData}
              logClientAction={props.logClientAction}
              clientsLogsData={props.clientsLogsData}
              clientsQuestData={props.clientsQuestData}
              clientsQuestSheetData={props.clientsQuestSheetData}
              tabIndex={props.tabIndex}
              uData={props.user}
              clientsFullData={clients}
              filesData={props.filesData}
            />
          ) : !showAddClient &&
            !showClientReport &&
            !showStatistics &&
            !showSearch ? (
            <>
              <div style={{ width: "100%" }} className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>

              <div className="paymentMenuContainer">
                {props.checkPermissions("dodajSprawe") ? (
                  <>
                    <button
                      style={{
                        backgroundColor: "#006d00",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      className="paymentMenuButton"
                      onClick={handleShowAddClient}
                    >
                      Dodaj sprawę
                    </button>
                  </>
                ) : (
                  ""
                )}
                <button
                  style={{
                    backgroundColor: "#876487",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "15px",
                  }}
                  className="paymentMenuButton"
                  onClick={handleShowStatistics}
                >
                  Statystyki
                </button>
                {props.checkPermissions("searchNote") ? (
                  <>
                    <button
                      style={{
                        backgroundColor: "blue",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      className="paymentMenuButton"
                      onClick={handleShowSearch}
                    >
                      Wyszukaj po notatce
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="desktopFilters">{desktopFilters}</div>
              <div className="mobileFilters">{mobileFilters}</div>

              <div id="testScroll" className="contentBoxPayments">
                <div className="desktopFilters">{clientsData}</div>
                <div className="mobileFilters">{clientsDataMobile}</div>
              </div>
              <div className="desktopFilters">
                <div
                  style={{
                    marginTop: "2vh",
                    display: "flex",
                    gap: "15px",
                  }}
                >
                  <span style={{ width: "130px" }}>
                    STR. {page}/{Math.ceil(clients.length / +perPage)}
                  </span>
                  <button
                    className="loginButtonLogin"
                    onClick={handleSubPage}
                    style={{
                      margin: "0",
                      backgroundColor: "rgb(0, 189, 206)",
                      borderColor: "orange",
                      fontSize: ".6vw",
                      width: "20px",
                      height: "2vh",
                      color: "white",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {"<"}
                  </button>
                  <button
                    className="loginButtonLogin"
                    onClick={handleAddPage}
                    style={{
                      margin: "0",
                      backgroundColor: "rgb(0, 189, 206)",
                      borderColor: "orange",
                      fontSize: ".6vw",
                      width: "20px",
                      height: "2vh",
                      color: "white",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {">"}
                  </button>
                </div>
              </div>

              <div className="mobileFilters">
                <div
                  style={{
                    marginTop: "2vh",
                    display: "flex",
                    gap: "15px",
                  }}
                >
                  <span style={{ width: "130px" }}>
                    STR. {page}/{Math.ceil(clients.length / +perPage)}
                  </span>
                  <button
                    className="loginButtonLogin"
                    onClick={handleSubPage}
                    style={{
                      margin: "0",
                      backgroundColor: "rgb(0, 189, 206)",
                      borderColor: "orange",
                      fontSize: "3vw",
                      width: "20px",
                      height: "2vh",
                      color: "white",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {"<"}
                  </button>
                  <button
                    className="loginButtonLogin"
                    onClick={handleAddPage}
                    style={{
                      margin: "0",
                      backgroundColor: "rgb(0, 189, 206)",
                      borderColor: "orange",
                      fontSize: "3vw",
                      width: "20px",
                      height: "2vh",
                      color: "white",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
      <div>
        {expandFilters ? (
          <div
            style={{ height: "100%" }}
            id="deatilClientsBox"
            className="detailFilters"
          >
            <div className="titleBox" id="tbClients">
              <button
                className="closeClientButton"
                onClick={handleExpandFiltersClick}
              >
                X
              </button>
            </div>
            <div className="filtersBox">
              <p style={{ marginTop: "0" }}>FILTRY ZAAWANSOWANE</p>
              <div id="hideFunClients" className="paymentMenuContainer">
                <div className="desktopFilters">
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterSpecialClient}
                      onChange={checkSpecialClientFilter}
                    />
                    Klienci szczególni
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterSTS}
                      onChange={checkSTSFilter}
                    />
                    Sędzia - teoria salda
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterSTSK}
                      onChange={checkSTSKFilter}
                    />
                    Sędzia - teoria salda (KZP w pełnej wysokości)
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterSUP}
                      onChange={checkSUPFilter}
                    />
                    Sędzia - uwzględnia potrącenie
                  </div>
                  <div
                    style={{
                      height: "4.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterT1}
                      onChange={checkT1ClientFilter}
                    />
                    Wykonane zadanie "Końcowe rozliczenie - sprawdzenie
                    płatności"
                  </div>

                  <div
                    style={{
                      height: "4.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterT1F}
                      onChange={checkT1FClientFilter}
                    />
                    Niewykonane zadanie "Końcowe rozliczenie - sprawdzenie
                    płatności"
                  </div>

                  <div
                    style={{
                      height: "4.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterT2F}
                      onChange={checkT2FClientFilter}
                    />
                    Pozew o nadpłatę: TAK
                  </div>

                  <div
                    style={{
                      height: "4.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPou}
                      onChange={checkPouClientFilter}
                    />
                    Pozew o ustalenie: TAK
                  </div>

                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterWezw}
                      onChange={checkWezwFilter}
                    />
                    Wezwania do zapłaty
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawyWezw}
                      onChange={checkPrawWezwFilter}
                    />
                    Brak prawnika - wezwanie do zapłaty
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawyOdpPozew}
                      onChange={checkOdpPozewFilter}
                    />
                    Brak prawnika - odpowiedzialność za pozew
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawySprPozew}
                      onChange={checkSprPozewFilter}
                    />
                    Brak prawnika - sprawdzający pozew
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterDocCompl}
                      onChange={checkDocComplFilter}
                    />
                    Komplet dokumentów klienta
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterNoContactData}
                      onChange={checkNoContactDatalFilter}
                    />
                    Brak danych kontaktowych
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterNoPayments}
                      onChange={checkNoPaymentsFilter}
                    />
                    Brak płatności
                  </div>
                  {+props.user.archSpraw === 1 ? (
                    <>
                      <div
                        style={{
                          height: "2.5vh",
                          fontWeight: "300",
                          fontSize: "0.8vw",
                          width: "100%",
                        }}
                        className="checkBox"
                      >
                        <input
                          style={{ width: "4%", height: "2vh" }}
                          id="checkCal2"
                          type="checkbox"
                          checked={filterArch}
                          onChange={checkArchFilter}
                        />
                        Archiwalne
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPayd}
                      onChange={checkPaydFilter}
                    />
                    Kredyt Spłacony
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPozWz}
                      onChange={checkPozWzFilter}
                    />
                    Pozew wzajemny
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPotrCl}
                      onChange={checkPotrClFilter}
                    />
                    Potrącenie otrzymane bezpośrednio przez klienta
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterZatrzPotr}
                      onChange={checkZatrzPotrFilter}
                    />
                    Zarzut potrącenia
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterCofCzP}
                      onChange={checkCofCzPFilter}
                    />
                    Cofnięcie częściowe pozwu po potrąceniu
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterNakZap}
                      onChange={checkNakZapFilter}
                    />
                    Nakaz zapłaty
                  </div>
                  <div className="desktopFilters">
                    <div
                      style={{
                        marginTop: "10px",
                        marginBottom: "5px",
                        fontSize: "0.8vw",
                      }}
                    >
                      GETIN
                    </div>
                  </div>
                  <div className="mobileFilters">
                    <div
                      style={{
                        marginTop: "10px",
                        marginBottom: "5px",
                        fontSize: "3vw",
                      }}
                    >
                      GETIN
                    </div>
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterGetinOpt1}
                      onChange={checkGetinOpt1Filter}
                    />
                    Kancelaria przygotowuje oświadczenie
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterGetinOpt2}
                      onChange={checkGetinOpt2Filter}
                    />
                    Kancelaria przygotowuje oświadczenie i zgł. wierzytelność
                  </div>
                  <div
                    style={{
                      height: "2.5vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterGetinSusp}
                      onChange={checkGetinSuspFilter}
                    />
                    Podjęte postępowanie po zawieszeniu
                  </div>
                </div>

                <div className="mobileFilters">
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterSpecialClient}
                      onChange={checkSpecialClientFilter}
                    />
                    Klienci szczególni
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterWezw}
                      onChange={checkWezwFilter}
                    />
                    Wezwania do zapłaty
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawyWezw}
                      onChange={checkPrawWezwFilter}
                    />
                    Brak prawnika - wezwanie do zapłaty
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawyOdpPozew}
                      onChange={checkOdpPozewFilter}
                    />
                    Brak prawnika - odpowiedzialność za pozew
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterLawySprPozew}
                      onChange={checkSprPozewFilter}
                    />
                    Brak prawnika - sprawdzający pozew
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterDocCompl}
                      onChange={checkDocComplFilter}
                    />
                    Komplet dokumentów klienta
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterNoContactData}
                      onChange={checkNoContactDatalFilter}
                    />
                    Brak danych kontaktowych
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterNoPayments}
                      onChange={checkNoPaymentsFilter}
                    />
                    Brak płatności
                  </div>
                  {+props.user.archSpraw === 1 ? (
                    <>
                      <div
                        style={{
                          height: "6vh",
                          fontWeight: "300",
                          fontSize: "0.8vw",
                          width: "100%",
                        }}
                        className="checkBox"
                      >
                        <input
                          style={{ width: "4%", height: "2vh" }}
                          id="checkCal2"
                          type="checkbox"
                          checked={filterArch}
                          onChange={checkArchFilter}
                        />
                        Archiwalne
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPayd}
                      onChange={checkPaydFilter}
                    />
                    Kredyt Spłacony
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterPozWz}
                      onChange={checkPozWzFilter}
                    />
                    Pozew wzajemny
                  </div>
                  <div className="desktopFilters">
                    <div
                      style={{
                        marginTop: "10px",
                        marginBottom: "5px",
                        fontSize: "0.8vw",
                      }}
                    >
                      GETIN
                    </div>
                  </div>
                  <div className="mobileFilters">
                    <div
                      style={{
                        marginTop: "10px",
                        marginBottom: "5px",
                        fontSize: "3vw",
                      }}
                    >
                      GETIN
                    </div>
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterGetinOpt1}
                      onChange={checkGetinOpt1Filter}
                    />
                    Kancelaria przygotowuje oświadczenie
                  </div>
                  <div
                    style={{
                      height: "6vh",
                      fontWeight: "300",
                      fontSize: "0.8vw",
                      width: "100%",
                    }}
                    className="checkBox"
                  >
                    <input
                      style={{ width: "4%", height: "2vh" }}
                      id="checkCal2"
                      type="checkbox"
                      checked={filterGetinOpt2}
                      onChange={checkGetinOpt2Filter}
                    />
                    Kancelaria przygotowuje oświadczenie i zgł. wierzytelność
                  </div>
                </div>
                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data zarzutu potrącenia
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={zatrzPortDateFilterFrom}
                        onChange={handleZatrzPotrDateFilterFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={zatrzPotrDateFilterTo}
                        onChange={handleZatrzPotrDateFilterTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleZatrzPotrDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>
                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data umowy z kancelarią
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={serviceDateFilterFrom}
                        onChange={handleServiceDateFilterFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={serviceDateFilterTo}
                        onChange={handleServiceDateFilterTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleServiceDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data wysyłki pozwu
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={lawsuitDateFilterFrom}
                        onChange={handleLawsuitDateFilterFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={lawsuitDateFilterTo}
                        onChange={handleLawsuitDateFilterTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleLawsuitDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data zaświadczenia
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={zaswDateFilterFrom}
                        onChange={handleZaswDateFilterFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={zaswDateFilterTo}
                        onChange={handleZaswDateFilterTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleZaswDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Data wezwania
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Od</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={wezwDateFilterFrom}
                        onChange={handleWezwDateFilterFrom}
                      />
                    </div>
                    <div
                      style={{ width: "45%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <label style={{ fontSize: ".8vw" }}>Do</label>
                      <input
                        style={{ height: "3vh" }}
                        type="date"
                        id="name"
                        name="name"
                        value={wezwDateFilterTo}
                        onChange={handleWezwDateFilterTo}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "2vh" }}>
                    <button
                      style={{
                        backgroundColor: "#00bdce",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "15px",
                      }}
                      id="clientsFilterButton"
                      className="paymentMenuButton"
                      onClick={handleWezwDateFilter}
                    >
                      Pokaż
                    </button>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Prawnik sporządzający wezwanie do zpałaty
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "100%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <select
                        style={{ height: "3vh" }}
                        value={lawyerWezwSearch}
                        onChange={handleLawyerWezwSearchChange}
                      >
                        <option key={0} value={"brak danych"}>
                          Brak danych
                        </option>
                        {props.lawyersData.map((el) => (
                          <option key={el.name} value={el.name}>
                            {el.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Prawnik sporządzający pozew
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "100%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <select
                        style={{ height: "3vh" }}
                        value={lawyerOdpPozwSearch}
                        onChange={handleLawyerOdpPozwSearchChange}
                      >
                        <option key={0} value={"brak danych"}>
                          Brak danych
                        </option>
                        {props.lawyersData.map((el) => (
                          <option key={el.name} value={el.name}>
                            {el.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Prawnik sprawdzający pozew
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "100%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <select
                        style={{ height: "3vh" }}
                        value={lawyerSprPozwSearch}
                        onChange={handleLawyerSprPozwSearchChange}
                      >
                        <option key={0} value={"brak danych"}>
                          Brak danych
                        </option>
                        {props.lawyersData.map((el) => (
                          <option key={el.name} value={el.name}>
                            {el.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Osoba rozliczająca sprawę
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "100%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <select
                        style={{ height: "3vh" }}
                        value={lawyerRozCaseSearch}
                        onChange={handleLawyerRozCaseSearchChange}
                      >
                        <option key={0} value={"brak danych"}>
                          Brak danych
                        </option>
                        {props.lawyersData.map((el) => (
                          <option key={el.name} value={el.name}>
                            {el.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <label style={{ fontSize: ".8vw", fontWeight: "600" }}>
                    Sędzia
                  </label>
                  <div style={{ marginTop: "5px" }} className="inputBox">
                    <div
                      style={{ width: "100%", minWidth: "auto" }}
                      className="inputCol_2"
                    >
                      <input
                        type="text"
                        id="clientsFilterInput"
                        name="name"
                        value={judgeSearch}
                        onChange={handleJudgeSearchChange}
                        style={{ height: "3vh", minHeight: "3vh" }}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "2vh" }}>
                  <button
                    style={{
                      backgroundColor: "#00bdce",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "15px",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={handleFilterClear}
                  >
                    Wyczyść filtr
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {showAddClient || showClientReport ? (
              ""
            ) : (
              <button
                style={{ width: "2vw", height: "6vh" }}
                className="expandButton"
                onClick={handleExpandFiltersClick}
              >
                F<br />←
              </button>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Clients;
